"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var foundation_1 = require("../../theme/foundation");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var core_1 = require("@emotion/core");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var faSync_1 = require("@fortawesome/free-solid-svg-icons/faSync");

exports.Loader = utils_2.forwardRef(function Grid(props, ref) {
  var children = props.children,
      loading = props.loading,
      spin = props.spin;
  var loaderContainer = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\t", "\n\t\t\t", "\n\t\t\t", "\n\t\t\t", "\n\t\t\t", "\n\t"], ["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\t", "\n\t\t\t", "\n\t\t\t", "\n\t\t\t", "\n\t\t\t", "\n\t"])), !loading && "display: flex;", !loading && "justify-content: center;", !loading && "align-items: center;", loading && "color: " + foundation_1.colors.primary.green + ";", loading && 'font-size: 1.5em;');
  return (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: loaderContainer
  }, loading ? (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
    icon: faSync_1.faSync,
    spin: spin
  }) : children);
});

if (utils_1.isDev) {
  exports.Loader.displayName = 'Loader';
}

var templateObject_1;